import { buildBaseOverrides } from 'Components/UI/guidedHouseholdReview/baseOverrides';
import { Text } from 'Packages/FacetDesign/Components/Text';
import { overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverrideLite';
import { FDBodyText } from '@facet-wealth/design';

export const metaOverrideSet = buildBaseOverrides()
  .nameOverride('description', {
    _component: () => Text,
    _customProps: { Component: FDBodyText, size: 'md', align: 'center' },
  }, overrideReadOnly);
